

// src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../core/data/redux/store'; 

interface ProtectedRouteProps {
	children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const accessToken = useSelector((state: RootState) => state.auth.accessToken);
	const location = useLocation();

	return accessToken ? (
		children ? (
			<>{children}</>
		) : (
			<Outlet />
		)
	) : (
		<Navigate to="/login" state={{ from: location }} replace />
	);
};
export default ProtectedRoute;
